<template>
  <v-sheet class="details-sheet" :color="color" v-bind="$attrs">
    <h3 v-if="showTitle" class="details-sheet__title title">
      <slot name="title" :item="item"> {{ title }}: </slot>
    </h3>

    <template v-for="({ text, value, custom }, index) in headers">
      <template v-if="`item.${value}` in $scopedSlots">
        <p :key="index" class="details-sheet__item">
          <strong class="details-sheet__item-name">{{ text }}:</strong>
          <slot :name="`item.${value}`" v-bind="{ item, text, value }" />
        </p>
      </template>
      <template v-else-if="custom">
        <p :key="index" class="details-sheet__item">
          <strong class="details-sheet__item-name">{{ text }}:</strong>
          <span class="details-sheet__value">{{ custom(item) }}</span>
        </p>
      </template>
      <p v-else :key="index" class="details-sheet__item">
        <strong class="details-sheet__item-name">{{ text }}:</strong>
        <span class="details-sheet__value">{{ getValue(value) }}</span>
      </p>
    </template>
  </v-sheet>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'DetailsSheet',

  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    headers: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Details'
    },
    color: {
      type: String,
      default: 'grey lighten-4'
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getValue(prop) {
      return get(this.item, prop, '');
    }
  }
};
</script>

<style lang="scss">
.details-sheet {
  & &__title,
  & &__item {
    display: block;
    margin-bottom: 1rem;
  }

  & &__item {
    font-size: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & &__item-name {
    margin-right: 0.4rem;
  }
}
</style>
